module.exports = __webpack_public_path__ + "static/media/SalesRevenue.78345f57.svg";